import { Button, Grid, TextField, Card, Box } from "@mui/material";
import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import { postSaveObjectApi, getObjectByPropertyApi, putUpdateObjectApi } from "api/general";
import { SUBJECT } from "app/utils/constants/customConstant";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";



function AddUpdateSubjectCard({ selectedSubject, onClose, addAfterTable, afterUpdateFunc }) {


    const empty_subjectObj = { name: '' }
    const [subjectObj, setSubjectObj] = useState(selectedSubject ? selectedSubject : empty_subjectObj)

    const handleChange = name => (e) => {

        setSubjectObj({
            ...subjectObj,
            [name]: e.target.value
        })
    }


    useEffect(() => {
        setSubjectObj(selectedSubject ? selectedSubject : empty_subjectObj)
    }, [selectedSubject])



    const handleAddUpdateSubjectInfo = () => {
        onClose();


        selectedSubject ?

            Swal.fire({
                title: 'Konu Güncelleme İşlemi',
                text: "Güncellemek istediğinizden emin misiniz?",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Evet Güncelle',
                cancelButtonText: "Vazgeç"
            }).then(async (result) => {
                if (result.isConfirmed) {

                    if (result.isConfirmed) {

                        const sameRecord = await getObjectByPropertyApi(SUBJECT, "name", subjectObj.name.toLowerCase());
                        if (sameRecord.data) {

                            Swal.fire({
                                title: 'Konu Güncelleme İşlemi',
                                text: "'" + sameRecord.data.name + "'" + " isimli konu olduğundan güncelleme yapılamamaktadır.",
                                icon: 'info',
                                confirmButtonText: 'Tamam'
                            })
                        } else {

                            const result = await putUpdateObjectApi(SUBJECT, subjectObj);
                            if (result.status) {
                                Swal.fire({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Güncelleme başarılı.',
                                    showConfirmButton: false,
                                    timer: 1500
                                });
                                afterUpdateFunc && afterUpdateFunc({ ...subjectObj });

                                // afterUpdateFunc({ id: result.data.insertId, ...subjectObj })

                            }

                        }

                    }
                }
            })

            :

            Swal.fire({
                title: 'Konu Ekleme İşlemi',
                text: "'" + subjectObj.name + "'" + " isimli konuyu eklemek istediğinizden emin misiniz?",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Evet Ekle',
                cancelButtonText: "Vazgeç"
            }).then(async (result) => {


                if (result.isConfirmed) {
                    const sameRecord = await getObjectByPropertyApi(SUBJECT, "name", subjectObj.name.toLowerCase());
                    if (sameRecord.data) {

                        Swal.fire({
                            title: 'Konu Ekleme İşlemi',
                            text: "'" + sameRecord.data.name + "'" + " isimli konu olduğundan eklenememektedir.",
                            icon: 'info',
                            confirmButtonText: 'Tamam'
                        })
                    } else {

                        const result = await postSaveObjectApi(SUBJECT, subjectObj);
                        if (result.status) {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'Ekleme başarılı.',
                                showConfirmButton: false,
                                timer: 1500
                            });

                            addAfterTable({ id: result.data.insertId, ...subjectObj })

                        }

                    }

                }
            })
    };




    return (
        <>

            <JumboCardQuick>

                <Grid container marginY={1} spacing={1} rowSpacing={1}>

                    <Grid item xs={6} md={12}>
                        <TextField
                            variant="outlined"
                            label="Konu Adı"
                            multiline fullWidth
                            value={subjectObj['name']}
                            onChange={handleChange("name")}
                        />
                    </Grid>

                </Grid>
            </JumboCardQuick >
            <br></br>

            <Card>
                <Box sx={{ margin: '8px' }}>
                    <Grid container justifyContent="flex-end" spacing={1}>
                        <Grid item>
                            <Button variant="contained" color="success" onClick={() => handleAddUpdateSubjectInfo()}>
                                {selectedSubject ? "Güncelle" : "Kaydet"}
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" color="error" onClick={() => onClose()}>
                                Kapat
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Card>

        </>
    )
}

export default AddUpdateSubjectCard